// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1ml-S","tab":"ProcedureTabs_tab__jR6Nu"};